import "./style.scss";
import { fxcmLoader } from "../../constants/ImageConstants";

const Loader = ({ 'data-testid': testId }) => {
	return (
		<div className="loader-class" data-testid={testId}>
			<div className="loader">
				<img className="loader-logo" src={fxcmLoader} alt="loaderLogo" width="42" height="46" />
			</div>
		</div>
	);
};

export default Loader;
